import React, {useState, useEffect} from "react";
import { useFetch} from "../../../../components/common/FetchProvider";
import Loader from "components/Loader/Loader";
import InputField from "components/fields/InputField";

const AccountModal = ({showModal, setModalState, refreshData, accountData, setAccountData}) => {
    const fetchWrapper = useFetch();
    const [errorMessages, setErrorMessages] = useState({});
    const [loading, setLoading] = useState(false);
    const [formData, setFormData] = useState({});
    const [formErrorData, setFormErrorData] = useState({});
    const [organizationData, setOrganizationData] = useState([]);
    const [isChecked, setIsChecked] = useState(false);

    const handleInputChange = (event) => {
        errorMessages.message = "";
        setFormErrorData({});
        const {id, value} = event.target;
        setFormData((prevState) => ({
            ...prevState,
            [id]: value,
        }));
    };

    const handleCheckboxChange = (event) => {
        setIsChecked(event.target.checked);
    };

    const setErrorForField = (field) => {
        setFormErrorData({[field]: "error"});
    }

    const errors = {
        accountType: "Please select Tipo",
        openingDate: "Please enter Data de abertura",
        intialBalanceDate: "Please enter Data saldo inicial",
        organizationId: "Please select Orgão",
        initialBalance: "Please enter valid Saldo inicial",
        joint: "Please select Conjunto",
        accountName: "Please enter valid Nome da conta",
        accountNumber: "Please enter valid Número",
        bankName: "Please enter valid Banco",
        accountCurrency: "Please select Moeda",
        apiError: "Something went wrong"
    };

    const validationRules = {
        accountType: {
            validate: (value) => value !== undefined && value !== "",
            message: errors.accountType,
        },
        openingDate: {
            validate: (value) => value !== undefined,
            message: errors.openingDate,
        },
        intialBalanceDate: {
            validate: (value) => value !== undefined,
            message: errors.intialBalanceDate,
        },
        organizationId: {
            validate: (value) => value !== undefined && value !== "",
            message: errors.organizationId,
        },
        initialBalance: {
            validate: (value) => value !== undefined,
            message: errors.initialBalance,
        },
        joint: {
            validate: (value) => value !== undefined && value !== "",
            message: errors.joint,
        },
        accountName: {
            validate: (value) => value && value.length >= 3,
            message: errors.accountName,
        },
        bankName: {
            validate: (value) => value && value.length >= 3,
            message: errors.bankName,
        },
        accountCurrency: {
            validate: (value) => value !== undefined && value !== "",
            message: errors.accountCurrency,
        },
    };

    useEffect(() => {
        fetchData();
        setExistingData(accountData)
        if (showModal) {
            document.body.style.overflow = "hidden";
        } else {
            document.body.style.overflow = "auto";
        }
        return () => {
            document.body.style.overflow = "auto";
        };
    }, [showModal, accountData]);

    const setExistingData = (data) => {
        if (data !== null && data !== undefined && data.id != null) {
            setFormData(data)
            setIsChecked(data.receiveFees)
        }
    }

    const handleCancel = () => {
        setAccountData(null);
        setModalState(false);
    }

    const fetchData = async () => {
        setLoading(true);
        try {
            let organizationrApiUrl = `${process.env.REACT_APP_API_URL}/v1/configuration/organization`;
            const userToken = localStorage.getItem("token");
            const organizationResponse = await fetchWrapper(organizationrApiUrl, {
                method: 'GET',
                headers: {
                    Authorization: `Bearer ${userToken}`,
                },
            });
            if (organizationResponse.ok) {
                const responseData = await organizationResponse.json();
                if (responseData.data && responseData.data.length > 0) {
                    setOrganizationData(responseData.data);
                }
            } else {
                setLoading(false);
                console.error('Error fetching organization API data:', organizationResponse.status);
            }

        } catch (error) {
            setLoading(false);
            console.error('Error fetching API data:', error);
        }
    };

    const handleSubmit = () => {
        for (let field in validationRules) {
            const {validate, message} = validationRules[field];
            if (!validate(formData[field])) {
                setErrorMessages({name: field, message: message});
                setErrorForField(field);
                return;
            }
        }
        if (formData.accountType === 'banco' && (formData.accountNumber === undefined || formData.accountNumber.trim() === "")) {
            setErrorMessages({name: 'accountNumber', message: errors.accountNumber});
            setErrorForField('accountNumber');
            return;
        }

        setLoading(true);
        const requestOptions = {
            method: accountData != null && accountData.id !== undefined ? "PUT" : "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + localStorage.getItem("token")
            },
            body: JSON.stringify({...formData, receiveFees: isChecked})
        };
        fetchWrapper(process.env.REACT_APP_API_URL + "/v1/configuration/accounts", requestOptions)
            .then((response) => response.json())
            .then((data) => {
                setLoading(false);
                if (data.responseInfo.status === "SUCCESS") {
                    setAccountData(null);
                    refreshData();
                    setModalState(false);
                } else {
                    setErrorMessages({
                        name: "apiError",
                        message: errors.apiError,
                    });
                }
            });
    };

    return (
        <>
            {showModal ? (
                <>
                    <Loader show={loading}/>
                    <div
                        className="fixed inset-0 z-50 flex items-center justify-center overflow-y-auto overflow-x-hidden outline-none focus:outline-none">
                        <div className="relative my-10 mx-auto w-full max-w-3xl sm:w-4/5 md:w-3/4 lg:w-2/3 xl:w-1/2">
                            <div
                                className="relative font-normal flex flex-col rounded-lg border-0 bg-white text-navy-800 shadow-lg outline-none focus:outline-none dark:!border-white/10 dark:!bg-navy-800 dark:text-white dark:shadow-none">

                                {/* Modal Header */}
                                <div
                                    className="flex items-start justify-between rounded-t border-b border-solid p-5 border-slate-200">
                                    <h4 className="text-3xl font-semibold">Adicionar/editar contas</h4>
                                </div>

                                {/* Modal Body */}
                                <div className="p-5 space-y-4" style={{ overflowY: "auto", maxHeight: "70vh" }}>
                                    <div className="text-red-500 min-h-[1.30rem]">{errorMessages.message}</div>

                                    {/* Row 1: Payment Date with Calendar Icon and Document Number */}
                                    <div className="flex space-x-4 items-start">
                                        {/* Payment Date Field */}
                                        <div className="w-full">
                                            <label
                                                className="text-sm  dark:text-white ml-1.5 font-medium">Tipo</label>
                                            <select
                                                className={`mt-2 flex h-12 w-full items-center justify-center rounded-xl border bg-white/0 p-3 text-sm outline-none dark:!border-white/10  ${
                                                    formErrorData.accountType === "error" ? "border-red-500" : ""
                                                }`}
                                                id="accountType"
                                                value={formData.accountType}
                                                onChange={handleInputChange}
                                            >
                                                <option value="">Selecione o tipo</option>
                                                <option value="banco">Banco</option>
                                                <option value="caixa">Caixa</option>
                                            </select>
                                        </div>

                                        <div className="w-full">
                                            <InputField
                                                extra="text-navy-800"
                                                variant="auth"
                                                label="Data de abertura"
                                                id="openingDate"
                                                type="date"
                                                state={formErrorData.openingDate === "error" ? "error" : ""}
                                                value={formData.openingDate}
                                                onChange={handleInputChange}
                                            />

                                        </div>
                                        <div className="w-full">
                                            <InputField
                                                extra="text-navy-800"
                                                variant="auth"
                                                label="Data saldo inicial"
                                                id="intialBalanceDate"
                                                type="date"
                                                state={formErrorData.intialBalanceDate === "error" ? "error" : ""}
                                                value={formData.intialBalanceDate}
                                                onChange={handleInputChange}
                                            />

                                        </div>
                                    </div>

                                    {/* Row 2: Full-Length Description Field */}
                                    <div className="flex space-x-4 items-start">
                                        <div className="w-full">
                                            <label
                                                className="text-sm  dark:text-white ml-1.5 font-medium">Orgão</label>
                                            <select
                                                className={`mt-2 flex h-12 w-full items-center justify-center rounded-xl border bg-white/0 p-3 text-sm outline-none dark:!border-white/10  ${
                                                    formErrorData.organizationId === "error" ? "border-red-500" : ""
                                                }`}
                                                id="organizationId"
                                                value={formData.organizationId}
                                                onChange={handleInputChange}
                                            >
                                                <option value="">Selecione o orgão</option>
                                                {organizationData.map((organization) => (
                                                    <option key={organization.id} value={organization.id}>
                                                        {organization.name}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                        <div className="w-full">
                                            <InputField
                                                variant="auth"
                                                label="Saldo inicial"
                                                placeholder="Saldo inicial"
                                                id="initialBalance"
                                                type="number"
                                                state={formErrorData.initialBalance === "error" ? "error" : ""}
                                                value={formData.initialBalance}
                                                onChange={handleInputChange}
                                            />
                                        </div>

                                        {/* Beneficiary Field */}

                                    </div>

                                    {/* Row 3: Full-Length Description Field */}
                                    <div className="flex space-x-4 items-start">
                                        <div className="w-full">
                                            <label
                                                className="text-sm  dark:text-white ml-1.5 font-medium">Conjunto</label>
                                            <select
                                                className={`mt-2 flex h-12 w-full items-center justify-center rounded-xl border bg-white/0 p-3 text-sm outline-none dark:!border-white/10  ${
                                                    formErrorData.joint === "error" ? "border-red-500" : ""
                                                }`}
                                                id="joint"
                                                value={formData.joint}
                                                onChange={handleInputChange}
                                            >
                                                <option value="">Selecione o conjunto</option>
                                                <option value="0">0</option>
                                                <option value="1">1</option>
                                                <option value="2">2</option>
                                                <option value="3">3</option>
                                                <option value="4">4</option>
                                                <option value="5">5</option>
                                                <option value="6">6</option>
                                                <option value="7">7</option>
                                                <option value="8">8</option>
                                                <option value="9">9</option>
                                                <option value="10">10</option>
                                                <option value="11">11</option>
                                                <option value="12">12</option>
                                                <option value="13">13</option>
                                                <option value="14">14</option>
                                                <option value="15">15</option>
                                            </select>
                                        </div>
                                        <div className="w-full">
                                            <InputField
                                                variant="auth"
                                                label="Nome da conta"
                                                placeholder="Nome da conta"
                                                id="accountName"
                                                type="text"
                                                state={formErrorData.accountName === "error" ? "error" : ""}
                                                value={formData.accountName}
                                                onChange={handleInputChange}
                                            />
                                        </div>
                                        <div className="w-full">
                                            <InputField
                                                variant="auth"
                                                label="Número"
                                                placeholder="Número"
                                                id="accountNumber"
                                                type="text"
                                                state={formErrorData.accountNumber === "error" ? "error" : ""}
                                                value={formData.accountNumber}
                                                onChange={handleInputChange}
                                            />
                                        </div>

                                    </div>

                                    {/* Row 4: Full-Length Description Field */}
                                    <div className="flex space-x-4 items-start">
                                        <div className="w-full">
                                            <InputField
                                                variant="auth"
                                                label="Banco"
                                                placeholder="Banco"
                                                id="bankName"
                                                type="text"
                                                state={formErrorData.bankName === "error" ? "error" : ""}
                                                value={formData.bankName}
                                                onChange={handleInputChange}
                                            />
                                        </div>
                                        <div className="w-full">
                                            <label
                                                className="text-sm  dark:text-white ml-1.5 font-medium">Moeda</label>
                                            <select
                                                className={`mt-2 flex h-12 w-full items-center justify-center rounded-xl border bg-white/0 p-3 text-sm outline-none dark:!border-white/10  ${
                                                    formErrorData.accountCurrency === "error" ? "border-red-500" : ""
                                                }`}
                                                id="accountCurrency"
                                                value={formData.accountCurrency}
                                                onChange={handleInputChange}
                                            >
                                                <option value="">Selecione o moeda</option>
                                                <option value="YJP">YJP</option>
                                                <option value="USD">USD</option>
                                                <option value="EUR">EUR</option>
                                                <option value="AKZ">AKZ</option>
                                            </select>
                                        </div>


                                    </div>
                                    <div className="mt-3 flex items-center gap-3">
                                        <label
                                            className="text-sm  dark:text-white ml-1.5 font-medium">Recebe
                                            Emolumentos</label>
                                        <input
                                            className="defaultCheckbox relative flex h-[20px] min-h-[20px] w-[20px] min-w-[20px] appearance-none items-center
      justify-center rounded-md border border-gray-300 text-white/0 outline-none transition duration-[0.2s]
      checked:border-none checked:text-white hover:cursor-pointer dark:border-white/10 checked:bg-brand-500 dark:checked:bg-brand-400"
                                            type="checkbox"
                                            checked={isChecked}
                                            onChange={handleCheckboxChange}
                                        />

                                    </div>

                                </div>

                                {/* Modal Footer */}
                                <div
                                    className="flex items-center justify-end p-5 border-t border-solid border-slate-200 rounded-b">
                                    <button
                                        onClick={handleCancel}
                                        className="linear mt-2 w-48 rounded-xl bg-brand-500 py-[12px] text-base font-medium text-white transition duration-200 hover:bg-brand-600 active:bg-brand-700 dark:bg-brand-400 dark:text-white dark:hover:bg-brand-300 dark:active:bg-brand-200">
                                        Cancelar
                                    </button>
                                    <button
                                        onClick={handleSubmit}
                                        className="linear mt-2 w-48 rounded-xl bg-brand-500 py-[12px] text-base font-medium text-white transition duration-200 hover:bg-brand-600 active:bg-brand-700 dark:bg-brand-400 dark:text-white dark:hover:bg-brand-300 dark:active:bg-brand-200 ml-auto"
                                    >
                                        Salvar
                                    </button>
                                </div>
                            </div>
                        </div>


                    </div>


                    {/*overlay*/}
                    <div className="bg-black opacity-90 fixed inset-0 z-40 backdrop-blur-2xl backdrop-filter"></div>
                </>
            ) : null}
        </>
    );
};

export default AccountModal;
